<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .no-padding-right > .board {
    border-radius: 15px 0 0 15px;
  }

  .compensate-padding-right > .board {
    border-radius: 24px;
  }

  ::v-deep .form {
    color: $salesflow-font-gray;
    font-size: 1rem !important;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.23px;
    min-height: 57vh;

    #file-input {
      padding: 12rem;

      .small-text {
        margin-top: 0.25rem;
        font-size: 1rem;
        letter-spacing: -0.18px;
      }
    }

    #file-uploaded {
      padding: 7.5rem;
      display: none;

      .success {
        color: $gray-dark;
        font-size: 1.125rem;
        margin-top: 30px;
      }
    }
  }

  .material-content {
    padding: 24px;
    min-height: 79vh;

    .wrapper-content {
      background-color: $salesflow-bg-body;
      border: 2px dashed #ccc6d7;
      border-radius: 15px;
    }

    .footer {
      @include salesflow-subtitle($font-weight: 400);

      strong {
        font-weight: 700;
      }
    }
  }

  .library {
    padding: 0rem;
  }

  .uploading {
    width: 80px;
    height: 100px;
    margin: 0 15px 10px;
  }

  .card-body {
    display: flex;
    flex-wrap: wrap;
  }

  .card-text {
    background-color: $salesflow-bg-content;
  }

  .file {
    display: flex;
    margin: 12px 15px;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid $salesflow-outline-gray-medium;
    background-color: $white;

    &:hover {
      transform: scale(1.01);
      box-shadow: 0 10px 15px -3px rgba(100, 100, 100, 0.1), 0 4px 6px -4px rgba(100, 100, 100, 0.1);
      text-decoration: none;
    }

    .description {
      width: 160px;
      padding: 0.5rem 1.5rem;
      text-align: center;
      @include salesflow-text(
        $color: $salesflow-font-gray,
        $font-weight: 500
      );
    }

    .preview {
      border-radius: 7px 7px 0 0;
      width: 160px;
      height: 160px;
    }
  }

  .empty-set label {
    color: #3b334a;
    font-size: 15px;
  }

  ::v-deep .material-nav-class {
    background-color: #F0F0F0;

    .nav-item {
      .nav-link {
        color: $salesflow-font-gray;
        font-weight: 600;
        padding: 4.5px 32px;
      }
      .nav-link.active {
        color: $salesflow-primary-hover;
        background-color: $salesflow-bg-content;
      }
    }
  }

</style>

<template>
  <section class="tenant-material">
    <div class="row">
      <div class="col-12 pl-30px d-flex align-items-center">
        <h2 class="page-subtitle">
          <span v-if="files.length === 0">{{ __('Você não possui') }}<strong> {{ __('nenhum material') }}</strong></span><span v-else>{{ __('Você possui') }}<strong v-if="files.length === 1"> {{ __('1 material') }}</strong><strong v-else> {{ files.length }} {{ __('materiais') }}</strong></span><span> {{ __('em sua conta') }}</span>
        </h2>
      </div>
    </div>
    <div :class="[ editing ? 'no-padding-right' : 'compensate-padding-right' ]">
      <div class="board d-flex with-shadow p-0 mt-2">
        <div class="material-panel w-100">
          <BCard no-body>
            <BTabs nav-class="material-nav-class">
              <BTab
                no-body
                :title=" __('Enviar arquivos')"
                @click="hideEdit()"
                active
              >
                <BCardText>
                  <div
                    class="material-content"
                    id="file"
                    style="width: 100%;"
                  >
                    <div class="wrapper-content">
                      <form
                        class="form"
                        v-dropzone="dropzone"
                      />
                    </div>
                    <div class="footer mt-4">
                      {{ __('Máximo permitido:') }}<strong> {{ __('10MB.') }}</strong>
                    </div>
                  </div>
                </BCardText>
              </BTab>
              <BTab
                no-body
                :title="__('Biblioteca de arquivos')"
              >
                <BCardText>
                  <div class="material-content">
                    <div
                      class="library card-body"
                      v-if="loading"
                    >
                      <span><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Carregando...') }}</span>
                    </div>
                    <div
                      class="library card-body"
                      v-else-if="files.length"
                    >
                      <a
                        class="file"
                        href="#"
                        :key="file.id"
                        :title="file.formated"
                        @click.prevent="edit(file)"
                        v-for="file in prepared"
                      >
                        <Preview
                          class="preview"
                          :file="file"
                          :svgComponent="file.svgComponent"
                        />
                        <div class="description">{{ file.formatted | truncate }}</div></a>
                    </div>
                    <div
                      class="empty-set big text-center"
                      v-else
                    >
                      <label>{{ __('Adicione novos materiais na aba Enviar arquivos.') }}</label>
                    </div>
                  </div>
                </BCardText>
              </BTab>
            </BTabs>
          </BCard>
        </div>
        <TenantMaterialEdit style="z-index: 0;" />
      </div>
    </div>
  </section>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BCardText,
} from 'bootstrap-vue';
import Preview from './MaterialPreview';
import IconPdfFile from '../icon/IconPdfFile.vue';
import IconPngFile from '../icon/IconPngFile.vue';
import IconJpgFile from '../icon/IconJpgFile.vue';
import IconGifFile from '../icon/IconGifFile.vue';
import IconXlsxFile from '../icon/IconXlsxFile.vue';

const types = [
  {
    icon: 'fa-file-o',
    extensions: [],
  },
  {
    iconComponent: IconPdfFile,
    extensions: ['pdf'],
  },
  {
    iconComponent: IconPngFile,
    extensions: ['png'],
  },
  {
    iconComponent: IconJpgFile,
    extensions: ['jpg', 'jpeg'],
  },
  {
    iconComponent: IconGifFile,
    extensions: ['gif'],
  },
  {
    iconComponent: IconXlsxFile,
    extensions: ['xlsx'],
  },
];

const defaultType = types[0];

export default {
  components: {
    Preview,
    BTabs,
    BTab,
    BCard,
    BCardText,
  },

  data () {
    return {
      files: [],
      editing: false,
      loading: true,
      totalFilesToSave: 0,
      filesSaved: 0
    };
  },

  created () {
    this.fetch();

    Bus.$on('deleteFile', (...args) => this.destroy(...args));
    Bus.$on('updateFile', (...args) => this.update(...args));
    Bus.$on('hideEdit', () => this.hideEdit());
  },

  computed: {
    prepared () {
      return this.files.map((file) => {
        const type = this.getType(file.extension);
        return {
          ...file,
          icon: type.icon,
          isSvgIcon: !!type.iconComponent,
          svgComponent: type.iconComponent,
        };
      });
    },


    dropzone () {
      const {
        __,
      } = this;

      return {
        action: '/file/upload?file=true&material=true',
        defaultMessage: '<div class="form">'
              + '<div id="file-input">'
                + `<div>${__('Arraste o arquivo aqui')}</div>`
                + `<div class="small-text ">${__('ou')}</div>`
                + `<button class="btn btn-primary mt-2 salesflow-btn-border" type="button">${__('Selecione seu arquivo')}</button>`
              + '</div>'
              + '<div id="file-uploaded">'
                + '<img src="/build/icons/green-checked@2x.svg" width="50px">'
                + `<div class="success">${__('Upload feito com sucesso.')}</div>`
                + `<div class="mt-4">${__('Acesse a biblioteca de arquivos para visualizar.')}</div>`
                + `<button class="btn btn-primary mt-5 mb-1px" type="button">${__('Clique aqui para adicionar mais')}</button>`
              + '</div>'
            + '</div>',
        isFilePublic: true,
        success: this.fileUploadedCallback,
        error: this.fileUploadedError,
        keepFiles: false,
        accept: (file, done) => {
          this.totalFilesToSave++;
          this.filesSaved = 0;
          done();
        }
      };
    },
  },

  methods: {
    fileUploadedError (e) {
      if (! e.accepted) {
        return Alert.error(this.__('Arquivo não aceito'));
      }

      if (e.xhr && e.xhr.status === 403) {
        const { error } = JSON.parse(e.xhr.response);

        if (error) {
          return Alert.error(error);
        }
      }

      if (e.xhr && e.xhr.status === 422) {
        const data = JSON.parse(e.xhr.response);

        Alert.error(data.file[0]);
      }

      const permittedFileTypes = ["image/jpeg", "image/gif", "image/png", "application/pdf"];
      if(!permittedFileTypes.includes(e.type)) {
        return Alert.error(this.__("Arquivo não compatível. O formato deve ser jpeg, jpg, gif, png, pdf ou xlsx."));
      }

      return Alert.error(this.__('Não foi possível fazer o upload do arquivo, verifique sua conexão ou tente novamente mais tarde.'));
    },

    fileUploadedCallback (e) {
      this.filesSaved++;

      let message;
      if (this.filesSaved % 2 === 0 || this.filesSaved === this.totalFilesToSave || this.totalFilesToSave === 1) {
        message = `${this.filesSaved} ${this.__(' de ')} ${this.totalFilesToSave} ${this.__('arquivo(s) importado(s) com sucesso!')}`;
      }

      if (this.filesSaved === this.totalFilesToSave) {
        this.totalFilesToSave = 0;
      }

      if (message) {
        Alert.success(message);
      }

      this.fetch();

      const fileInput = document.getElementById('file-input');
      const fileUploaded = document.getElementById('file-uploaded');

      fileInput.classList.add('d-none');
      fileUploaded.classList.add('d-block');
    },

    fetch () {
      this.loading = true;

      this.$http.get('/file?ajax=true')
        .then(({ data }) => {
          if (! data.length) {
            throw new Error('Empty');
          }

          this.files = data;
        })
        .catch(({ message }) => {
          if (message === 'Empty') {
            this.files = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    prepare (file) {
      return { ...file, ...this.getType(file.extension) };
    },

    getType (extension) {
      return types.find((type) => type.extensions.indexOf(extension) != -1) || defaultType;
    },

    edit (file) {
      this.editing = true;

      Bus.$emit('editFile', file);
    },

    hideEdit () {
      this.editing = false;

      Bus.$emit('hideEditFile');
    },

    update (id, title, promise) {
      const file = this.files.find((file) => file.id == id);
      const old = file.title;

      file.title = title;

      this.$http.put(`/file/${id}`, { title })
        .then(() => this.editing = false)
        .then(() => promise)
        .then(() => Alert.success(this.__('Arquivo atualizado')))
        .catch(() => {
          file.title = old;

          Alert.error(this.__('Erro ao atualizar arquivo!'));
        });
    },

    destroy (id, promise) {
      const index = this.files.findIndex((file) => file.id == id);
      const file = this.files.splice(index, 1);

      this.$http.delete(`/file/${id}`)
        .then(() => this.editing = false)
        .then(() => promise)
        .then(() => Alert.success(this.__('Arquivo excluído')))
        .catch(() => {
          this.files.splice(index, 0, file[0]);

          Alert.error(this.__('Erro ao excluir arquivo.'));
        });
    },
  },
};
</script>
